import Campo from './Campo';

interface PassoTermoProps {
  termo: string;
  aceito: boolean;
  nomeAssinatura: string;
  destaque: 'aceite' | 'aceite_nome' | null;
  erro: string | null;
  aoMarcar: (valor: boolean) => void;
  aoMudarNome: (valor: string) => void;
}

function ehTituloNumerado(linha: string): boolean {
  return /^\s*[1-7]\s*[.)]/.test(linha);
}

// Passo 3 — termo de autorização e assinatura.
export default function PassoTermo({
  termo,
  aceito,
  nomeAssinatura,
  destaque,
  erro,
  aoMarcar,
  aoMudarNome,
}: PassoTermoProps) {
  const linhas = termo.split('\n');

  return (
    <div>
      <h2 className="text-[17px] font-bold text-foreground-950">Autorização</h2>
      <p className="mt-1 text-[15px] leading-relaxed text-foreground-700">
        Leia com calma. Isso vale como autorização dos pais ou responsáveis.
      </p>

      <div className="mt-4 max-h-[55vh] overflow-y-auto rounded-2xl border border-background-200 bg-white p-4">
        <div className="space-y-2 text-[15px] leading-relaxed text-foreground-800">
          {linhas.map((linha, indice) =>
            linha.trim() === '' ? (
              <div key={`linha-${indice}`} className="h-1" />
            ) : (
              <p
                key={`linha-${indice}`}
                className={ehTituloNumerado(linha) ? 'font-bold text-foreground-950' : ''}
              >
                {linha}
              </p>
            ),
          )}
        </div>
      </div>

      <button
        type="button"
        id="campo-aceite"
        role="checkbox"
        aria-checked={aceito}
        aria-label="Li e aceito o termo de autorização e responsabilidade"
        onClick={() => aoMarcar(!aceito)}
        className={`aperta mt-4 flex w-full cursor-pointer items-start gap-3 rounded-xl border p-3.5 text-left transition-colors ${
          destaque === 'aceite'
            ? 'border-danger-400 bg-danger-50'
            : aceito
              ? 'border-primary-300 bg-primary-50'
              : 'border-background-200 bg-white'
        }`}
      >
        <span
          className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md border-2 ${
            aceito ? 'border-primary-500 bg-primary-500 text-white' : 'border-secondary-400 bg-white'
          }`}
        >
          {aceito && <i className="ri-check-line text-base" aria-hidden />}
        </span>
        <span className="min-w-0 flex-1 text-[15px] font-medium leading-snug text-foreground-900">
          Li e aceito o termo de autorização e responsabilidade
        </span>
      </button>

      <div
        id="campo-assinatura"
        className={`mt-4 rounded-xl p-3.5 ${
          destaque === 'aceite_nome' ? 'border border-danger-400 bg-danger-50' : ''
        }`}
      >
        <Campo
          rotulo="Seu nome completo (vale como assinatura)"
          valor={nomeAssinatura}
          aoMudar={aoMudarNome}
          placeholder="Escreva seu nome"
          erro={destaque === 'aceite_nome' ? 'Escreva seu nome completo.' : null}
          autoComplete="off"
        />
      </div>

      {erro && (
        <p className="mt-3 flex items-start gap-1.5 text-[14px] text-danger-600" role="alert">
          <span className="mt-0.5 flex h-4 w-4 shrink-0 items-center justify-center">
            <i className="ri-error-warning-line" aria-hidden />
          </span>
          {erro}
        </p>
      )}
    </div>
  );
}